const scholacityText= 'https://drive.google.com/file/d/1If0s0kxK2UQTd-1eTnTtqfBKHOCLc9Ne/view?usp=sharing';

export default scholacityText;